export const COLLAGE_SVG_COMPONENTS = {
  EMPTY_PHOTO: 'collage-empty-photo',
  NOTE: 'Note',
  LAYOUT: 'Layout',
  COVER: 'Cover',
  MASK: 'Mask',
  SHADOW: 'Shadow',
  TEXT: 'Text',
  LOADER_BACKGROUND: 'collage-loader-background',
  EXCLUDED: 'excluded',
}

export const NON_LAYOUT_RECTS = [
  COLLAGE_SVG_COMPONENTS.EMPTY_PHOTO,
  COLLAGE_SVG_COMPONENTS.LOADER_BACKGROUND,
] // classNames for <rect> that aren't part of the "Layout"
export const MAX_COLLAGE_IMAGE_SIZE = 1500 // Maximum image size in pixels (width or height)
